import React from 'react';

import { Carousel } from 'antd';
import { CaretUpFilled } from '@ant-design/icons';
import { PlantType } from '../../../utils/types';
import Link from '../../../components/Link';

function PlantPictures(props) {
  const { plant } = props;

  return (
    <div className="PlantPictures">
      <div className="PlantPictures__header">
        <h3>Photos</h3>
        <div>
          <Link to={`/plant/${plant.id}`}>
            <CaretUpFilled />
          </Link>
        </div>
      </div>

      <Carousel>
        {plant.pictures.map(picture => (
          <img key={picture} alt={plant.name} src={picture} />
        ))}
      </Carousel>
    </div>
  );
}

PlantPictures.propTypes = {
  plant: PlantType.isRequired,
};

export default PlantPictures;
